import { useEffect, useState } from "react"
import "./FotoGallery.css"
import { Link, useParams } from 'react-router-dom';

export default function Slideshow() {
    const indirizzo = useParams().index;
    const album = indirizzo.slice(0, indirizzo.length - 1);
    const [albumDisplay, setAlbumDisplay] = useState("");
    const indiceIniziale = parseInt(indirizzo.slice(indirizzo.length - 1, indirizzo.length));
    const [slideNum, setSlide] = useState(indiceIniziale);
    const [totale, setTotale] = useState(0);

    useEffect(() => {
        if (album == "cantieri") {
            setTotale(130)
            setAlbumDisplay("cantieri")
        }
        else {
            setTotale(18);
            setAlbumDisplay("nostra lavorazione")
        }
    })
    const next = () => { if (slideNum < totale) setSlide(slideNum + 1) }
    const prev = () => { if (slideNum > 1) setSlide(slideNum - 1) }

    return (
        <section>
            <br />
            <div className="exitButton">
                <div style={{display:"flex", alignItems:"center"}}>
                    <Link to="/gallery" 
                        style={{display:"flex", flexDirection: "row", alignItems:"center",
                        textDecoration:"none"}}>
                        <ion-icon id="frecce_slideshow" name="arrow-back-outline"></ion-icon>
                    <p className="help">
                        Torna alla gallery.
                    </p>
                    </Link>
                </div>
                <p className="help">
                    Sei nella sezione "{albumDisplay}".
                    Foto {slideNum}/{totale}.
                </p>
            </div>
            <div className="anteprima">
                <div className="comandi_laterali">
                    <ion-icon id="frecce_slideshow" name="chevron-back-outline"
                        onClick={() => prev()}
                        style={{ backgroundColor: "#E5E5E5", borderRadius: "1vw" }}></ion-icon>
                </div>
                <div>
                    <img src={"https://infislab.it/foto/gallery/".concat(album + slideNum, ".jpg")}
                        id="immagine"
                        className="foto_fullScreen" loading="lazy" />
                </div>
                <div className="comandi_laterali">
                    <ion-icon id="frecce_slideshow" name="chevron-forward-outline"
                        onClick={() => next()}
                        style={{ backgroundColor: "#E5E5E5", borderRadius: "1vw" }}></ion-icon>
                </div>
            </div>
        </section>
    )
}
